/** Supabase Edge Function that emails form submissions via Resend (supabase/functions/send-form) */
const FORM_ENDPOINT = "https://ayjgfoeevktywpkqyspm.supabase.co/functions/v1/send-form";

/** Public Cloudflare Turnstile site key (the secret lives in Supabase) */
export const TURNSTILE_SITE_KEY = "0x4AAAAAAFDlojcPvd1658Yi";

export type FormType = "contact" | "website";

/** Posts a form's fields; throws if the email wasn't sent. */
export async function sendForm(
  form: FormType,
  fields: Record<string, string | undefined>,
  guard: { token: string; trap: string },
) {
  const response = await fetch(FORM_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ form, fields, token: guard.token, website_url: guard.trap }),
  });
  if (!response.ok) throw new Error("Failed to send form");
}
